import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchAddress({ commit, state }, id) {

      commit('RESET_STATE');
      if (id == 0)
        return;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/user/address/'+id+'/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    address: state => state.data?state.data:{},
    addressLoading: state => state.loading,
    addressError: state => state.error,
    addressLoaded: state => state.loaded,
  }
})